import React, { useState, useRef, useEffect } from 'react';
import './App.css';
import toWav from 'audiobuffer-to-wav';

const API_KEY = '214b4d66-5261-41f3-9ade-5a211ea46d69';
const apiUrl = 'https://api.carterlabs.ai/api/chat';

const players = [
  { id: 'james', name: 'James' },
  { id: 'bambi', name: 'Peyton' },
  { id: 'peyton', name: 'Peyton' },
  { id: 'testProfile', name: 'Test Profile'}
];

const PlayerSelector = ({ selectedPlayer, onSelectPlayer }) => {
  return (
    <select value={selectedPlayer} onChange={(e) => onSelectPlayer(e.target.value)}>
      <option value="">Set the Relationship:</option>
      {players.map((player) => (
        <option key={player.id} value={player.id}>
          {player.name}
        </option>
      ))}
    </select>
  );
};

function App() {
  const [userInput, setUserInput] = useState('');
  const [chatMessages, setChatMessages] = useState([]);
  const [recording, setRecording] = useState(false);
  const [audioChunks, setAudioChunks] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState('');
  const [isPlayingAudio, setIsPlayingAudio] = useState(false);
  const mediaRecorderRef = useRef(null);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [chatMessages]);

  const handleSendMessage = () => {
    if (userInput.trim() !== '') {
      displayMessage(userInput, 'user');
      setIsTyping(true);

      fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          text: userInput,
          key: API_KEY,
          user_id: selectedPlayer,
          speak: true,
        })
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.json();
        })
        .then(data => {
          const responseAudioUrl = data.output.audio;
          const responseText = data.output.text;

          if (responseAudioUrl) {
            const responseAudio = new Audio(responseAudioUrl);
            setIsTyping(false);
            setIsPlayingAudio(true);
            separateAndDisplayMessage(responseText);
            responseAudio.addEventListener('ended', () => {
              setIsPlayingAudio(false);
              separateAndDisplayMessage(responseText); // Display typing after audio ends
            });
            responseAudio.play();
          } else {
            setIsTyping(false);
            separateAndDisplayMessage(responseText);
          }
        })
        .catch(error => {
          console.log('Error:', error);
        });

      setUserInput('');
    }
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSendMessage();
    }
  };

  const separateAndDisplayMessage = (message) => {
    const regex = /(^.*?)```([\s\S]*?)```/g;
    let match;
    let lastIndex = 0;

    while ((match = regex.exec(message)) !== null) {
      const preText = message.substring(lastIndex, match.index).trim();
      if (preText) {
        displayMessage(preText, 'bot');
      }

      const codeBlock = match[2].trim();
      displayCodeBlock(codeBlock);

      lastIndex = regex.lastIndex;
    }

    const remainingText = message.substring(lastIndex).trim();
    if (remainingText) {
      displayMessage(remainingText, 'bot');
    }
  };

  const displayMessage = (message, sender) => {
    const newMessage = {
      content: message,
      sender,
      timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    };

    setChatMessages(prevMessages => [...prevMessages, newMessage]);
  };

  const displayCodeBlock = (code) => {
    const newMessage = {
      content: code,
      sender: 'bot-code',
      timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    };

    setChatMessages(prevMessages => [...prevMessages, newMessage]);
  };

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="master-div max-w-[480px] mx-auto h-screen overflow-hidden rounded-lg bg-black">
        <div className="flex flex-col h-full bg-black text-white">
          <header className="sticky top-0 py-6 bg-black">
            <h1 className="text-4xl font-bold mb-2 text-white text-center">Meet Trio</h1>
            <div className="subheader-container">
              {isTyping && !isPlayingAudio ? (
                <div className="typing-animation text-gray-400">
                  Trio is <span className="typing"> TYPING...</span>
                </div>
              ) : isPlayingAudio ? (
                <div className="notification-wrapper">
                  <div className="notification-speaking">
                    <div className="circle"></div>
                    <div className="circle"></div>
                    <div className="circle"></div>
                    <div className="circle"></div>
                    <div className="circle"></div>
                  </div>
                </div>
              ) : (
                <h2 className="text-2xl font-semibold text-gray-400 text-center">The Ai-Powered Code Buddy</h2>
              )}
              <div className="player-selector text-center">
                <PlayerSelector selectedPlayer={selectedPlayer} onSelectPlayer={setSelectedPlayer} />
              </div>
            </div>
          </header>
          <div className="flex-grow overflow-y-auto bg-black px-4 pb-4">
            <ul id="chat-messages" className="list-none">
              {chatMessages.map((message, index) => (
                <li key={index} className={message.sender === 'user' ? 'text-right pb-5' : 'text-left pb-5'}>
                  {message.sender !== 'bot-code' ? (
                    <div style={{ position: 'relative' }}>
                      <span
                        className={`inline-block bg-${message.sender === 'user' ? 'black-600' : 'green-600'} text-white px-4 py-2 rounded-lg`}
                        style={{
                          marginBottom: '5px'
                        }}
                      >
                        {message.content}
                      </span>
                      {message.sender !== 'user' && (
                        <div
                          className="message-timestamp"
                          style={{
                            position: 'absolute',
                            bottom: '0',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            marginTop: '10px',
                            visibility: 'hidden'
                          }}
                        >
                          <span
                            className="text-xs text-gray-400 bg-opacity-50 bg-black px-2 py-1 rounded-lg"
                            style={{ zIndex: 1 }}
                          >
                            {message.timestamp}
                          </span>
                        </div>
                      )}
                    </div>
                  ) : (
                    <pre
                      className="bg-black rounded-lg p-4 text-white"
                      style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap' }}
                    >
                      <code>{message.content}</code>
                    </pre>
                  )}
                </li>
              ))}
              <div ref={messagesEndRef} />
            </ul>
          </div>
          <div className="flex items-center justify-between">
            <input
              type="text"
              id="user-input"
              className="shadow appearance-none border rounded-l w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline bg-white"
              placeholder="Hey Trio..."
              value={userInput}
              onChange={e => setUserInput(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <button
              id="send-message"
              className="ml-2 bg-purple-500 hover:bg-purple-700 rounded-r px-4 py-2 text-white focus:outline-none"
              onClick={handleSendMessage}
            >
              Send
            </button>
          </div>
          <footer className="sticky bottom-0 bg-black px-4 py-4">
            <p className="text-gray-500 text-center">
              Developed by{' '}
              <a href="https://www.eden.dev" target="_blank" rel="noopener noreferrer" className="glowing-text">
                The Eden Alliance
              </a>{' '}
              2023.<br />
              This is an internal demo and not to be shared.
            </p>
          </footer>
        </div>
      </div>
    </div>
  );
}

export default App;
